import { Button, makeStyles, Theme } from '@freighthub/silhouette-core'
import { FC } from 'react'
import { useI18n } from 'utils/localisation'

const useStyles = makeStyles<Theme>((theme) => ({
  container: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center',
  },
  text: {
    paddingBottom: theme.spacing(2),
  },
}))

export const PageLoadError: FC = () => {
  const classes = useStyles()
  const { translate } = useI18n()
  const { onLine } = navigator

  const fullReload = () => {
    window.location.reload()
  }

  return (
    <div className={classes.container}>
      <div className={classes.text}>
        {onLine ? (
          <div>{translate('page_load_error-text_error')}</div>
        ) : (
          <div>{translate('page_load_error-text_no_connection')}</div>
        )}
      </div>
      <Button variant="contained" onClick={fullReload}>
        {translate('page_load_error-button_reload')}
      </Button>
    </div>
  )
}
